// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__3Llg1","tab":"TabNav_tab__c6hvm","link":"TabNav_link__2Wsxo","selectedLink":"TabNav_selectedLink__1Fzwx","disabled":"TabNav_disabled__3ak5-"};